import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const RitualCard = ({ image, imageAlt, title, frequency, description, participants }) => {
  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden hover:shadow-elevation-2 transition-all duration-300 hover:scale-102">
      <div className="relative h-48 overflow-hidden">
        <Image 
          src={image} 
          alt={imageAlt}
          className="w-full h-full object-cover transition-transform duration-300 hover:scale-110"
        />
        <div className="absolute top-3 right-3 bg-primary/90 backdrop-blur-sm px-3 py-1 rounded-full">
          <span className="text-xs font-semibold text-primary-foreground">{frequency}</span>
        </div>
      </div>
      <div className="p-5">
        <h3 className="text-lg font-bold text-foreground mb-2">{title}</h3>
        <p className="text-sm text-muted-foreground mb-4 leading-relaxed">{description}</p>
        <div className="flex items-center gap-2 text-xs text-muted-foreground">
          <Icon name="Users" size={16} color="var(--color-muted-foreground)" />
          <span>{participants} participants</span>
        </div>
      </div>
    </div>
  );
};

export default RitualCard;